module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "chapter",
      "role": "doc-chapter"
    }
  }, [_c('h2', {
    staticClass: "h2chap"
  }, [_c('span', {
    attrs: {
      "aria-label": "page 14",
      "epub:type": "pagebreak",
      "id": "page_14",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("CHAPTER 1 "), _c('span', {
    staticClass: "heading_break1"
  }, [_vm._v("Terms and Context")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("As we begin this journey together, let us consider a few key terms to establish our collective vocabulary: "), _c('i', [_vm._v("embodiment")]), _vm._v(", "), _c('i', [_vm._v("soma")]), _vm._v(", "), _c('i', [_vm._v("somatics")]), _vm._v(", "), _c('i', [_vm._v("somatic psychology")]), _vm._v(", "), _c('i', [_vm._v("somatic therapy")]), _vm._v(", and "), _c('i', [_vm._v("somatic psychotherapy")]), _vm._v(". You may already have a notion of what these terms mean, both in their definitions and in what they mean to you personally. Take a moment to write down your current understanding of these words in a notebook or on a piece of paper. How do you define them based on your knowledge and experience? What do they mean to you? What is your experience with each of them? What are the differences between them, and how do they overlap and intersect?")]), _vm._v(" "), _c('p', {
    staticClass: "noindq"
  }, [_vm._v("EMBODIMENT:")]), _vm._v(" "), _c('p', {
    staticClass: "noindq"
  }, [_c('span', {
    attrs: {
      "aria-label": "page 15",
      "epub:type": "pagebreak",
      "id": "page_15",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("SOMA:")])]), _vm._v(" "), _c('p', {
    staticClass: "noindq"
  }, [_vm._v("SOMATICS:")]), _vm._v(" "), _c('p', {
    staticClass: "noindq"
  }, [_vm._v("SOMATIC PSYCHOLOGY:")]), _vm._v(" "), _c('p', {
    staticClass: "noindq"
  }, [_c('span', {
    attrs: {
      "aria-label": "page 16",
      "epub:type": "pagebreak",
      "id": "page_16",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("SOMATIC THERAPY:")])]), _vm._v(" "), _c('p', {
    staticClass: "noindq"
  }, [_vm._v("SOMATIC PSYCHOTHERAPY:")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Let’s look a little more specifically now. Perhaps some of the following explanations will refine, clarify, enhance, or affirm your current understanding.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3x"
  }, [_vm._v("Embodiment")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('i', [_vm._v("Embodiment")]), _vm._v(" describes the experience and process of fully inhabiting your skin in such a way that your thoughts, actions, feelings, and intentions find a cohesive expression through your body. It is when you unequivocally exhibit and represent that thing you are describing. When we say someone is the embodiment of grace, we might be referring to the way they are inhabiting their movements, speech, and qualities of life. Embodiment is how you take your insides and show them on your outside. Embodiment looks like allowing life to impact you and expressing that impact in clear ways. It is about feeling your own aliveness in your skin through sensations as you move through the world. Embodiment is about staying present internally while experiencing life. It is the experience that occurs "), _c('span', {
    attrs: {
      "aria-label": "page 17",
      "epub:type": "pagebreak",
      "id": "page_17",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("when you are simultaneously aware of yourself inside your body, of the world around you, and of how you are experiencing them.")])]), _vm._v(" "), _c('h4', {
    staticClass: "h4x"
  }, [_vm._v("Embodiment, Dissociation, and Trauma")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Embodiment is the antithesis, and therefore antidote to, dissociation, the phenomenon of vacating one’s bodily experience as a result of overwhelm, stress, and trauma."), _c('span', {
    attrs: {
      "href": "#/e9781646040964/xhtml/endnotes#endnote-001",
      "id": "endnote-001-backlink",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("1")])]), _vm._v(" Dissociation is a rather normal response to trauma. It serves to protect you from feeling any more pain than is necessary. Trauma occurs when an event or a relationship dynamic overwhelms your nervous system to the point of massive reactivity for survival."), _c('span', {
    attrs: {
      "href": "#/e9781646040964/xhtml/endnotes#endnote-002",
      "id": "endnote-002-backlink",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("2")])]), _vm._v(" Dissociation is one of its hallmarks and can become an ingrained stress response so that even once the original threat has passed, this unconscious survival tactic plays out."), _c('span', {
    attrs: {
      "href": "#/e9781646040964/xhtml/endnotes#endnote-003",
      "id": "endnote-003-backlink",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("3")])]), _vm._v(" At the time of impact, dissociation protects your system, but over time this pattern of splitting and cutting off can become a recurrent and perpetual lived state that is unsatisfying at best and harming at worst. Patterns of dissociative behavior play out in our addictions, routines of self-medicating, and general disconnect from our bodies."), _c('span', {
    attrs: {
      "href": "#/e9781646040964/xhtml/endnotes#endnote-004",
      "id": "endnote-004-backlink",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("4")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The opposite of dissociation is embodiment—inhabiting your lived experience totally and fully. In this way, the path of embodiment is rather humbling. It is a path that requires your presence and fortitude to be impacted by all of life, not just by what is pleasant. Embodiment is a path that takes life on life’s terms and hones our capacity to stay connected to ourselves and the world around us even when it is unpleasant, scary, dull, overloaded, and everything in between. Embodiment’s best friend is presence, and together they cultivate the conversation of your ability to stay awake and attend to the experiences inside your skin while you are moving through life."), _c('span', {
    attrs: {
      "href": "#/e9781646040964/xhtml/endnotes#endnote-005",
      "id": "endnote-005-backlink",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("5")])]), _vm._v(" This is one of the primary reasons we know that embodiment helps repair traumatic experiences. Stress, overwhelm, and trauma send us outside of our bodily homes."), _c('span', {
    attrs: {
      "href": "#/e9781646040964/xhtml/endnotes#endnote-006",
      "id": "endnote-006-backlink",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("6")])]), _vm._v(" The unwinding of trauma must therefore include the body—your body. This reorienting to the home of your body is a process of embodiment.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Even if you have not incurred serious trauma, consider that embodiment is actually good for you. There is a common notion that avoiding negative experiences and compartmentalizing ourselves to separate from what we dislike is easier. This is why we see the rising tide of addiction, self-medicating, avoidance of true feelings, and lack of emotional vocabulary. Being present in your own skin actually helps you process and "), _c('span', {
    attrs: {
      "aria-label": "page 18",
      "epub:type": "pagebreak",
      "id": "page_18",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("digest experiences more efficiently."), _c('span', {
    attrs: {
      "href": "#/e9781646040964/xhtml/endnotes#endnote-007",
      "id": "endnote-007-backlink",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("7")])]), _vm._v(" Instead of thinking about things, you can feel and respond in coherent ways. It helps you stay connected to what is true in your mind and heart, and it provides pathways for that expression so that emotions, experiences, and responses do not get stifled or truncated. In this way, I suggest to you that embodiment is actually stress relieving and innately tied to increased well-being. Or perhaps a better way to put it is that the very exercises and activities that we engage in to move toward embodiment are stress relieving and encourage our well-being: Slowing down. Pausing. Consciously breathing. Feeling our skin. Moving in ways that are not just routinized and are instead endlessly authentic. Allowing ourselves to feel fully.")])]), _vm._v(" "), _c('h3', {
    staticClass: "h3x"
  }, [_vm._v("Soma")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("In Greek, "), _c('i', [_vm._v("soma")]), _vm._v(" means “of the body.” In English, it is defined as “the body of an organism,”"), _c('span', {
    attrs: {
      "href": "#/e9781646040964/xhtml/endnotes#endnote-008",
      "id": "endnote-008-backlink",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("8")])]), _vm._v(" and in Sanskrit, it translates to “the nectar of immortality.”"), _c('span', {
    attrs: {
      "href": "#/e9781646040964/xhtml/endnotes#endnote-009",
      "id": "endnote-009-backlink",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("9")])]), _vm._v(" Soma, your soma, is the organism of your body and all the intelligence of experience it holds. It is the fabric of your being—threading your experiences through the organism of your body. Soma is the vessel through which you give and receive life. It holds your emotions and expresses your thoughts and habits. You are made of soma, and you are soma itself.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3x"
  }, [_vm._v("Somatics")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('i', [_vm._v("Somatics")]), _vm._v(" is the study and practice of exploring and understanding the fabric of your soma through your internal awareness."), _c('span', {
    attrs: {
      "href": "#/e9781646040964/xhtml/endnotes#endnote-010",
      "id": "endnote-010-backlink",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("10")])]), _vm._v(" Somatic practices include movement and meditative techniques that invite you into a deep awareness of what it feels like to be inside your own skin as you inhabit it, whether in motion or in stillness. Somatic practices develop your embodiment and awareness—your "), _c('i', [_vm._v("proprioception")]), _vm._v(", how your body moves in space, and your "), _c('i', [_vm._v("interoception")]), _vm._v(", the experience of your body’s internal sensations and movements."), _c('span', {
    attrs: {
      "href": "#/e9781646040964/xhtml/endnotes#endnote-011",
      "id": "endnote-011-backlink",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("11")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Methods can include attention to the quality of your breath during movement. What it feels like to move inside your body while you move, make shapes, and shift your body weight. What it feels like to experience being in your body as it gives and receives in the world. Somatics, in this way, is really the study of experiencing yourself in and through your own embodied living.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3x"
  }, [_c('span', {
    attrs: {
      "aria-label": "page 19",
      "epub:type": "pagebreak",
      "id": "page_19",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("Somatic Psychology")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Christine Caldwell, one of the pioneers in the theory and practice of contemporary somatic psychology, defines the field as “the study of the body-mind connection. It draws upon philosophy, medicine, and other sciences in an attempt to unify human beings into an organic whole for the purpose of healing and transformation.”"), _c('span', {
    attrs: {
      "href": "#/e9781646040964/xhtml/endnotes#endnote-012",
      "id": "endnote-012-backlink",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("12")])]), _vm._v(" The robust field of somatic psychology has a wide lineage base and draws upon various somatic modalities, traditional talk therapy techniques, neuroscience, attachment theory, and trauma healing to approach the health and healing of one’s entire system. Looking at the individual as a whole organism means that one’s body and mind are not separate. Rather, they are woven together intricately in the ways our thoughts and emotions express outwardly, how life events and opportunities impact our movement repertoires, how our unconscious manifests somatically, and how somatic awareness can reveal the unconscious to us.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3x"
  }, [_vm._v("Somatic Therapy")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('i', [_vm._v("Somatic therapy")]), _vm._v(" is the application of somatic (body-mind) techniques for repair, integration, and healing at the biomechanical, physiological, neurological, and motor coordination levels. Somatic therapies address issues of the body such as motor delays, neurological impairment and decline, movement repatterning, and physical trauma to the body, as well as issues of the soma such as psychosomatic symptoms of stress and disease. Interventions can include gross and subtle movement, visualization, focused breathing, bodywork, and visceral manipulation. These interventions also affect the emotional and psychological health and development of the individual, which is inherently therapeutic and often psychotherapeutic."), _c('span', {
    attrs: {
      "href": "#/e9781646040964/xhtml/endnotes#endnote-013",
      "id": "endnote-013-backlink",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("13")])]), _vm._v(" The key here is that the inroad for somatic therapy is primarily for healing at the physical level that may then affect the mind and emotions.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("For example, yoga may easily be considered a somatic therapy. The various techniques of the yoga postural practice work specifically at the layer of the physical body to create imprints in the deeper layers of one’s being and consciousness. We do not consider going to yoga class the same as going to a therapist, but there is much truth to a saying I hear often, “Yoga is my therapy.” Often people find that by utilizing body-centered practices to facilitate the conversation between their lived experience of physical expression, their thought patterns, and their emotions, a kind of well-being and overall health emerges. "), _c('span', {
    attrs: {
      "aria-label": "page 20",
      "epub:type": "pagebreak",
      "id": "page_20",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("Repair often occurs in and through these practices without one sitting in a psychotherapy office. We might say that all somatic therapies provide healing to undernourished, undersupported, and sometimes wounded places within, yet the overarching approach is to work directly with the physical body—muscles, bones, fascia, breath, motor coordination, and movement—with a potential benefit of psychological and emotional shifts.")])]), _vm._v(" "), _c('h3', {
    staticClass: "h3x"
  }, [_vm._v("Somatic Psychotherapy")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Much like somatic therapy, "), _c('i', [_vm._v("somatic psychotherapy")]), _vm._v(" addresses the body-mind fabric toward healing and repair where needed. The inroad here is facilitating the health, repair, and healing of psychological, emotional, and developmental needs and traumatic experiences. Much like any psychotherapeutic model, which is really about healing places of abuse, trauma, neglect, distrust, and emotional dis-ease of all kinds, somatic psychotherapy offers this kind of healing but does so somatically—directly through the body.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Methods of somatic psychotherapy utilize various body-centered techniques to support the psychological health, healing, wholeness, and well-being of the individual."), _c('span', {
    attrs: {
      "href": "#/e9781646040964/xhtml/endnotes#endnote-014",
      "id": "endnote-014-backlink",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("14")])]), _vm._v(" Particular attention is focused on places where one’s psychosocial-emotional development may have been interrupted or wounded,"), _c('span', {
    attrs: {
      "href": "#/e9781646040964/xhtml/endnotes#endnote-015",
      "id": "endnote-015-backlink",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("15")])]), _vm._v(" as well as repairing wounds rooted in relational attachment"), _c('span', {
    attrs: {
      "href": "#/e9781646040964/xhtml/endnotes#endnote-016",
      "id": "endnote-016-backlink",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("16")])]), _vm._v(" and, of course, trauma-related wounds and their respective symptoms."), _c('span', {
    attrs: {
      "href": "#/e9781646040964/xhtml/endnotes#endnote-017",
      "id": "endnote-017-backlink",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("17")])]), _vm._v(" Another hallmark of somatic psychotherapy is its focus on the nervous system as an embodied function and experience."), _c('span', {
    attrs: {
      "href": "#/e9781646040964/xhtml/endnotes#endnote-018",
      "id": "endnote-018-backlink",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("18")])]), _vm._v(" Thus, somatic psychotherapy implements interventions that ignite individuals’ capacity to rewire their nervous system reactions into healthy responses, thereby generating a new embodied experience.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("A somatic psychotherapy intervention might look like utilizing movement to physically execute a behavior that was repressed or dismissed during the impact of a traumatic event. When finally allowed to emerge and sequence through one’s body, this expression brings relief and creates a new pathway of health within one’s system."), _c('span', {
    attrs: {
      "href": "#/e9781646040964/xhtml/endnotes#endnote-019",
      "id": "endnote-019-backlink",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("19")])]), _vm._v(" Somatic psychotherapists might also explore a bodily sensation as a means to access deeper emotional awareness and literacy in relationships and responses to life events."), _c('span', {
    attrs: {
      "href": "#/e9781646040964/xhtml/endnotes#endnote-020",
      "id": "endnote-020-backlink",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("20")])]), _vm._v(" Practitioners often assess psychosocial-emotional development through the structures and contours of posture and movement and utilize sensory awareness and movement to foster developmentally appropriate growth."), _c('span', {
    attrs: {
      "href": "#/e9781646040964/xhtml/endnotes#endnote-021",
      "id": "endnote-021-backlink",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "sup"
  }, [_vm._v("21")])])]), _vm._v(" "), _c('h3', {
    staticClass: "h3x"
  }, [_c('span', {
    attrs: {
      "aria-label": "page 21",
      "epub:type": "pagebreak",
      "id": "page_21",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("Overlapping Approaches")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("There are many areas in which somatic therapy and somatic psychotherapy overlap. For the purposes of this workbook, I encourage you to not get bogged down by these intricacies and subtle differences but instead to move through the content at your own pace with a mindset of self-healing for your soma. As a somatic psychotherapist, I am oriented toward the developmental, psychological, and emotional places of need in my clients. I listen and look for where this might be showing up in their bodies’ movements, gestures, and felt experiences, and I help them use the direct experience of their bodies to support their psychological and emotional repair and health. As a somatic movement therapist and educator, which includes predominantly my work as a yoga teacher and free-form movement guide, I work directly with movement and physicality to support health in my clients’ bodies and nervous systems. If and when emotional and psychological content emerges, I encourage and support their bodies to hold the experience as it unwinds. The difference here is really offering them resources and support rather than processing the material together as we do in psychotherapy. Yoga, 5Rhythms, and Authentic Movement, for example, are all somatic practices that can be applied therapeutically to support physical, emotional, and psychological well-being. Although they may not be psychotherapy per se, we may call them inherently therapeutic.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("In a culture that is device-driven, fast-paced, predominantly sedentary, and focused on how efficiently our minds can process information and produce, embodiment and somatics offer us a return to our birthright of living inside a body. These practices require slowing down, paying attention, breathing consciously, and turning away from the screen and into the wild inner terrain of our selves. Whether this is done on one’s own or with a safe other as a witness, the invitation into somatic practice is an invitation to return to the joy, fear, and humility of being in a body, of being a body, of being a human being. The more we can stay connected to our soma—to our somatic experience, to our innate wealth of health in our breath—the more we can reorient when things are difficult, return to the source of resilience within, and emanate that into our world. If embodiment is our birthright and soma is what we are made of, then it makes sense that we would use a practice rooted in the body to provide therapeutic intervention and change when needed.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a9fcb578","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9781646040964/xhtml/ch01.vue
// module id = 72
// module chunks = 0